import { isServer } from '@app/utils';

import browser from './client.browser';
import server from './client.server';

export const apolloClient = isServer ? server : browser;
